"use strict";

import React, { forwardRef } from "react";
import classNames from "classnames";
import { Text } from "../Text";
import * as styles from "./Spinner-css";
var spinnerSizes = /* @__PURE__ */new Map([["s", 18], ["m", 32], ["l", 64]]);
var strokeWidths = /* @__PURE__ */new Map([["s", 2], ["m", 3], ["l", 4]]);
export var Spinner = forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "m" : _ref$size,
    style = _ref.style,
    className = _ref.className,
    primary = _ref.primary,
    message = _ref.message;
  var spinnerSize = spinnerSizes.get(size) || 32;
  var strokeWidth = strokeWidths.get(size) || 3;
  var radius = spinnerSize / 2;
  var offsetRadius = radius - strokeWidth / 2;
  var circumference = spinnerSize * Math.PI;
  return /* @__PURE__ */React.createElement("div", {
    className: classNames(className, styles.container({
      primary: primary
    })),
    style: style
  }, /* @__PURE__ */React.createElement("svg", {
    className: styles.element,
    fill: "none",
    strokeWidth: strokeWidth,
    width: spinnerSize,
    height: spinnerSize,
    strokeLinecap: "round",
    viewBox: "".concat(radius, " ").concat(radius, " ").concat(spinnerSize, " ").concat(spinnerSize),
    ref: ref
  }, /* @__PURE__ */React.createElement("circle", {
    className: styles.path,
    cx: spinnerSize,
    cy: spinnerSize,
    r: offsetRadius,
    strokeOpacity: 0.2
  }), /* @__PURE__ */React.createElement("circle", {
    className: styles.path,
    cx: spinnerSize,
    cy: spinnerSize,
    r: offsetRadius,
    strokeDasharray: "".concat(circumference / 4, " ").concat(circumference),
    strokeDashoffset: circumference
  })), !!message && /* @__PURE__ */React.createElement(Text, {
    strong: true,
    size: "xs",
    align: "center",
    className: styles.message
  }, message));
});